<div *ngIf="!displayCartPage">
  <div class="modal-header">
    <div>
      <i class="mdi mdi-map-marker-multiple"></i>
      <span class="header title">{{ pageConfigurations?.title }}</span>
      <i
        *ngIf="!singleSelection"
        class="mdi mdi-information-outline info-icon"
        matTooltip="Select multiple items by holding shift key while click dragging over rows"
      ></i>
    </div>
    <div class="btn-group">
      <div class="add-new-endpoint" *ngIf="cartView" (click)="addUnmanagedDevice()">
        <span>+</span><span class="new_endpoint">New endpoint</span>
      </div>
      <button
        mat-flat-button
        *ngIf="!cartView"
        (click)="onSave()"
        class="save-btn"
        [disabled]="disableSave()"
      >
        SAVE
      </button>
      <button
        mat-flat-button
        (click)="addtoCart()"
        class="save-btn"
        [disabled]="!pickerComp?.deviceTable?.selection?.length > 0"
        *ngIf="cartView"
      >
        <i class="mdi mdi-server-plus cart-icon-size"></i>
        Add to {{ pageConfigurations?.selectionType }}
      </button>
      <button
        mat-flat-button
        (click)="openCartPage()"
        class="save-btn"
        [disabled]="disableCart()"
        *ngIf="cartView"
      >
        <span class="cart-count">
          {{ getCartCount() }}
        </span>
        <i class="mdi mdi-router-network cart-icon-size review-icon"></i>
        Review {{ pageConfigurations?.selectionType }}
      </button>
      <i class="mdi mdi-close close-icon" (click)="showAlertPopup()"></i>
    </div>
  </div>
  <div class="device-picker-content device-picker-list" *ngIf="tableData">
    <nrwl-cart-picker-table
      [tableData]="tableData"
      [cartItems]="cartItems"
      [singleSelection]="singleSelection"
      [persistenceID]="persistenceID"
      [cartView]="cartView"
      (updateCartItems)="updateCartItems($event)"
      [transformationString]="transformationString"
      [selectionLimit]="selectionLimit"
      [childRows]="childRows"
    ></nrwl-cart-picker-table>
  </div>
</div>
<div *ngIf="displayCartPage">
  <div class="modal-header">
    <div class="cart-page-header">
      <i class="mdi mdi-check-circle icon-tick"></i>
      <span class="header cart-page-count">Review {{ pageConfigurations?.selectionType }}</span>
    </div>
    <div class="btn-group">
      <button class="select-more" mat-stroked-button (click)="openPickerView()">
        <i class="mdi mdi-view-list-outline cart-icon-size"></i>
        Add more
      </button>
      <button mat-flat-button (click)="onSave()" class="save-btn" [disabled]="disableAddItems()">
        Save {{ pageConfigurations?.selectionType }}
      </button>
      <i class="mdi mdi-close close-icon" (click)="showAlertPopup()"></i>
    </div>
  </div>
  <div class="device-picker-content device-picker-list">
    <div *ngIf="cartItems && cartItems.length > 0">
      <nrwl-cart-list-table
        [cartItems]="cartItems"
        (updateCartItems)="updateCartItems($event)"
      ></nrwl-cart-list-table>
    </div>
  </div>
</div>
